// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"303":"component---node-modules-bufox-gatsby-theme-parkio-src-pages-404-js","579":"component---node-modules-bufox-gatsby-theme-parkio-src-pages-index-js"}[chunkId] || chunkId) + "-" + {"108":"990e2b3a360437e982e1","303":"be55c7f58ddae30d6c01","452":"a511fb2eb7584c8ea9a4","579":"c02136cb1a61b510b625"}[chunkId] + ".js";
};